import http_validate from '../http_validate'

export default {
  show(filter) {
    return http_validate.get('/client_order_details/client_order', {params: {...filter}, headers: {'OrderToken': sessionStorage.getItem('order_token')}})
  },

  validate(order_tk){
    return http_validate.post(`/client_order_details/validate`, null, {headers: {'OrderToken': order_tk}})
  },

}